import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Constants } from 'app/modules/common/constants/constants';
import { AbsenteeismChartTypes } from 'app/modules/common/enums/absenteeism-chart-types';
import { ChartService } from 'app/modules/coordinator/services/chart.service';
import { ChartDataset, ChartOptions } from 'chart.js';

@Component({
    selector: 'app-chart-popup',
    templateUrl: './chart-popup.component.html',
    styleUrls: ['./chart-popup.component.scss'],
    standalone: false
})
export class ChartPopupComponent implements OnInit {

  public title = '';
  public isLoading = true;

  public chartOptions: ChartOptions;
  public absenteeismData: ChartDataset[];
  public selectedChartType: AbsenteeismChartTypes = AbsenteeismChartTypes.Acumulado;

  constructor(
    private dialogRef: MatDialogRef<ChartPopupComponent>,
    public chartService: ChartService) { }

  ngOnInit(): void {
    this.isLoading = true;
    this.initChart();
    this.absenteeismData = this.chartService.getAbsenteeismData(this.selectedChartType);
    this.isLoading = false;
  }

  public initChart(): void {
    this.chartOptions = {
      responsive: true,
    };
  }

  public cancel(): void {
    this.dialogRef.close();
  }

}
